import React from 'react'

const PageContext = React.createContext({})
export const PageContextProvider = PageContext.Provider

export function usePageContext() {
  return React.useContext(PageContext)
}
